module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (76).ad8c26bc.jpg";